import * as postMessage from './postMessage';

export default function ga(...args) {
    postMessage.sendMessageToHost(postMessage.Intent.WIX_CODE_SITE_API, {
        command: postMessage.MessageTypes.GOOGLE_ANALYTICS,
        data: args
    });
}
